import { sessionsList, lessonsList, coursesBatchesList, adminsCoursesAndBatches, adminsSessionsList, attendanceList, channelPartnerCoursesAndBatches, channelPartnerSessionsWiseAttendanceList } from "constants/attendanceModule";


const initialState = {
  coursesBatchesList: {},
  lessonsList: {},
  sessionsList: {},
  adminsCoursesAndBatches: {},
  adminsSessionsList: {},
  attendanceList: {},
  channelPartnerCoursesAndBatches: {},
  channelPartnerSessionsWiseAttendanceList: {},
};

const attendanceModule = (state = initialState, action) => {
  switch (action.type) {
    case coursesBatchesList:
      return { ...state, coursesBatchesList: action.payload };

    case lessonsList:
      return { ...state, lessonsList: action.payload };

    case sessionsList:
      return { ...state, sessionsList: action.payload };

    case adminsCoursesAndBatches:
      return { ...state, adminsCoursesAndBatches: action.payload };

    case adminsSessionsList:
      return { ...state, adminsSessionsList: action.payload };

    case attendanceList:
      return { ...state, attendanceList: action.payload };

    case channelPartnerCoursesAndBatches:
      return { ...state, channelPartnerCoursesAndBatches: action.payload };

    case channelPartnerSessionsWiseAttendanceList:
      return { ...state, channelPartnerSessionsWiseAttendanceList: action.payload };


    default:
      return state;
  }
};

export default attendanceModule;